import { setInavLocation } from '../ducks/requestDuck';
import { convertPage } from './convertPage';

export const createInav = (pathname, dispatch) => {
  const [page] = pathname.split('/').slice(3);

  let locationINav = `${convertPage(page)}-hotels`;
  if (page === undefined || page === 'hotels' || page === '') {
    locationINav = 'hp-hotels';
  }

  dispatch(setInavLocation(locationINav));
};
